<template>
  <div>
    <div v-if="dealer" class="mb-10">
      <back-button :backURL="backURL" :title="title" />
    </div>
    <v-skeleton-loader
      v-else
      max-width="300px"
      type="text"
    ></v-skeleton-loader>

    <div v-if="windowWidth <= 768 && dealer">
      <v-bottom-navigation
        grow
        v-model="bottomNav"
      >
        <router-link v-for="button in firstRowBtns" tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
      <v-bottom-navigation
        grow
        v-model="bottomNav2"
      >
      </v-bottom-navigation>
    </div>
    <div v-else-if="windowWidth >= 768 && dealer">
      <v-bottom-navigation
        grow
        v-model="bottomNav"
      >
        <router-link v-for="button in desktopNav" tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
    </div>
    <v-skeleton-loader
      v-else
      class="mx-auto mb-10"
      type="image"
    ></v-skeleton-loader>
    <transition
      name="fade"
      mode="out-in"
    >
        <router-view v-if="dealer" class="mb-10" />
      <v-skeleton-loader
        v-else
        class="mx-auto mb-10"
        type="image"
      ></v-skeleton-loader>
    </transition>
  </div>
</template>

<script>
import BackButton from '~/components/BackButton';

export default {
  name: 'DealerProfile',
  metaInfo() {
    return { title: this.$t('dealers') };
  },
  props: {
    dealerId: { required: false },
    id: { required: false },
  },
  components: {
    BackButton,
  },
  data: () => ({
    bottomNav: 'profileDealer',
    bottomNav2: '',
    backURL: 'dealers',
    firstRowBtns: [
      {
        route: 'dealer.profileDealer',
        name: 'profileDealer',
        title: 'Perfil',
        icon: 'mdi-account',
      },
      {
        route: 'dealer.usersDealer',
        name: 'usersDealer',
        title: 'Usuarios',
        icon: 'mdi-account-key',
      },
      {
        route: 'dealer.enterprises',
        name: 'enterprises',
        title: 'Empresas',
        icon: 'fas fa-city',
      },
      {
        route: 'dealer.services',
        name: 'services',
        title: 'Paquetes',
        icon: 'mdi-credit-card',
      },
    ],
    name: '',
  }),
  computed: {
    dealer() {
      return this.$store.state.profile.dealer;
    },
    windowWidth() {
      return this.$store.state.window.width;
    },
    desktopNav() {
      return this.firstRowBtns;
    },
    title() {
      return `Distribuidor: <b>${this.name}</b>`;
    },
  },
  methods: {
    buildRoute(route) {
      if (this.dealerId) {
        return `${route}`;
      }
      return route;
    },
  },
  created() {
    this.$store.dispatch('profile/resetDealer');
  },
  async mounted() {
    window.axios.get(`/api/catalogs/dealers/${this.dealerId}`)
    .then((result) => {
      this.name = result.data.razonSocial;
      this.$store.dispatch('profile/setCurrentDealer', { dealer: result.data });
      if (this.dealer.activo === 0) {
        this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'usersDealer'), 1);
        this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'enterprises'), 1);
        this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'services'), 1);
      }
    });
  },
};
</script>
